import PageSubtitle from "./PageSubtitle";

export default PageSubtitle;
